var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19995 3.75005C5.56483 3.75005 5.04995 4.26492 5.04995 4.90005C5.04995 5.53517 5.56483 6.05005 6.19995 6.05005L12.6236 6.05005L11.1368 7.53688C10.6877 7.98598 10.6877 8.71412 11.1368 9.16322C11.5859 9.61233 12.314 9.61233 12.7631 9.16322L16.2131 5.71322C16.4288 5.49756 16.55 5.20505 16.55 4.90005C16.55 4.59505 16.4288 4.30254 16.2131 4.08688L12.7631 0.636876C12.314 0.187773 11.5859 0.187773 11.1368 0.636876C10.6877 1.08598 10.6877 1.81412 11.1368 2.26322L12.6236 3.75005L6.19995 3.75005Z",
    fill: "#CCCDD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 15.2501C11.4351 15.2501 11.95 14.7352 11.95 14.1001C11.95 13.4649 11.4351 12.9501 10.8 12.9501L4.3763 12.9501L5.86313 11.4632C6.31223 11.0141 6.31223 10.286 5.86313 9.83688C5.41402 9.38777 4.68588 9.38777 4.23678 9.83688L0.786778 13.2869C0.571111 13.5025 0.449951 13.7951 0.449951 14.1C0.449951 14.405 0.571111 14.6976 0.786778 14.9132L4.23678 18.3632C4.68588 18.8123 5.41402 18.8123 5.86312 18.3632C6.31223 17.9141 6.31223 17.186 5.86312 16.7369L4.3763 15.25L10.8 15.2501Z",
    fill: "#CCCDD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.b624ef4d.svg";
export { ForwardRef as ReactComponent };